import { render, staticRenderFns } from "./QuestChallengeComponent.vue?vue&type=template&id=74283071&"
import script from "./QuestChallengeComponent.vue?vue&type=script&lang=ts&"
export * from "./QuestChallengeComponent.vue?vue&type=script&lang=ts&"
import style0 from "./QuestChallengeComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports